var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEffectiveness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#92d2f4",
    d: "M202,102A100,100,0,1,1,102,2,100,100,0,0,1,202,102"
  }), /*#__PURE__*/React.createElement("path", {
    className: "level-1",
    d: "M44.3,134.63h12a5,5,0,0,1,5,5v11.75a5,5,0,0,1-5,5h-12a5,5,0,0,1-5-5V139.63a5,5,0,0,1,5-5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "level-2",
    d: "M70.16,112.88h12a5,5,0,0,1,5,5v33.5a5,5,0,0,1-5,5h-12a5,5,0,0,1-5-5v-33.5a5,5,0,0,1,5-5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "level-3",
    d: "M96,91.12h12a5,5,0,0,1,5,5v55.26a5,5,0,0,1-5,5H96a5,5,0,0,1-5-5V96.12a5,5,0,0,1,5-5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "level-4",
    d: "M121.88,69.37h12a5,5,0,0,1,5,5v77a5,5,0,0,1-5,5h-12a5,5,0,0,1-5-5v-77a5,5,0,0,1,5-5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "level-5",
    d: "M147.74,47.62h12a5,5,0,0,1,5,5v98.76a5,5,0,0,1-5,5h-12a5,5,0,0,1-5-5V52.62a5,5,0,0,1,5-5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffectiveness);
export default __webpack_public_path__ + "static/media/effectiveness.9ddd670b.svg";
export { ForwardRef as ReactComponent };